<template>
      <div class="xs-12 p4">
            <core-form-input
                  componentName="j-base-select"
                  name="code"
                  :options="options.loadingCodes"
                  :label="$t('loading_code')"
                  v-validate="'required'"
                  v-model="form.code"
                  :validationErrors="errors"
            />

            <div class="flex wrap xs-12 mt6">
                  <div class="xs-12 md-6 md-pr2">
                        <core-form-input
                              componentName="j-base-select"
                              name="type"
                              :options="options.type"
                              :label="$t('type')"
                              v-validate="'required'"
                              v-model="form.type"
                              :validationErrors="errors"
                        />
                  </div>
                  <div class="flex xs-12 md-6 md-pl2 mt6 md-mt0">
                        <div
                              :class="[
						{ 'xs-11': form.type === 'ratio' },
						{ 'xs-12': form.type === 'flat' }
					]"
                        >
                              <core-form-input
                                    componentName="j-base-input-number"
                                    name="amount"
                                    :label="$t('amount')"
                                    v-validate="'required'"
                                    v-model="form.amount"
                                    :validationErrors="errors"
                              />
                        </div>
                        <!-- If ratio show percentage -->
                        <div class="flex xs-center xs-middle xs-1 pt6" v-if="form.type === 'ratio'">%</div>
                  </div>
            </div>

            <!-- Buttons -->
            <div class="flex xs-between mt6">
                  <j-button :isLoading="isLoading" @click="handleSave" action="saveLoading">{{ $t("save") }}</j-button>
                  <j-button @click="handleCancel" type="bordered">{{ $t("cancel") }}</j-button>
            </div>
      </div>
</template>

<script>
/**
 * This component is responsible for creation of premium loading
 * Premium loading can be added on offer or directly on policy
 * It's a smart component calling APIs
 */
import CoreFormInput from "@/modules/core/components/CoreFormInput"
import JButton from "@/components/JButton"
import api from "../api/"
import get from "lodash.get"

export default {
	components: {
		CoreFormInput,
		JButton
	},

	props: {
		policyId: {
			type: String,
			required: true,
			default: ""
		},

		offerId: {
			validate(val) {
				return typeof val === "string" || val === null
			},
			required: false,
			default: null
		},

		productId: {
			type: Object,
			required: true,
			default: () => ({
				plan: null,
				type: null,
				version: null
			})
		}
	},

	data() {
		return {
			// When saving is in progress
			isLoading: false,

			// Form payload
			form: {
				code: null,
				amount: null,
				type: "ratio" // flat or ratio
			},

			// Options for select boxes
			options: {
				type: [
					{ name: this.$t("percentage"), value: "ratio" },
					{ name: this.$t("flat"), value: "flat" }
				],
				loadingCodes: []
			}
		}
	},

	methods: {
		async fetchLoadingSettings() {
			const res = await api.loadingSettings({
				where: { productId: this.productId }
			})

			// Process codes
			const codes = get(
				res,
				"data.products_2.list[0].loadingSettings.codeNames",
				[]
			)
			if (!codes) return

			// Prepare it for select box
			this.options.loadingCodes = codes.map(item => ({
				name: `${item.code} - ${item.name}`,
				value: item.code
			}))
		},

		async handleSave() {
			const isValid = await this.$validator.validate()
			if (!isValid) return

			// Perepare loadingInput
			const input = {
				code: this.form.code,
				offerId: this.offerId,
				// If it's ratio add ratio/100, if it's flat add just flat
				[this.form.type === "ratio" ? "ratio" : "flat"]:
					this.form.type === "ratio"
						? this.form.amount / 100
						: this.form.amount
			}

			// Call api
			this.isLoading = true
			const res = await api.addLoading({
				policyId: this.policyId,
				input
			})
			this.isLoading = false

			// Check errors
			if (res.errors) {
				this.$store.dispatch("showError", res.errors)
				return
			}

			// Emit
			this.$emit("created")
		},

		handleCancel() {
			this.$emit("cancelled")
		}
	},

	created() {
		this.fetchLoadingSettings()
	}
}
</script>
